<div class="se-preview-msg-container">
  <img src="./assets/icons/info.svg" alt="" />
  <span>{{ message }}</span>
</div>
